<template>
  <span class="d-none" aria-hidden="true" />
</template>

<script setup>
/**
 * Один API-запрос products по card_category (+ pipeline_mode).
 * Держит useApi вне цикла родителя.
 */
import { ref, watch } from 'vue'
import { useApi } from 'soykajs/composables/api'
import { buildHomeKanbanQuery } from './columns'

const props = defineProps({
  source: { type: Object, required: true },
  search: { type: String, default: '' },
})

const emit = defineEmits(['update'])

const lm = ref(
  buildHomeKanbanQuery({
    category: props.source.category,
    pipelineMode: props.source.pipelineMode,
    search: props.search,
  })
)

const { model, pending } = useApi({
  url: 'products',
  data: { total_count: 0, data: [] },
  query: lm,
  watch: lm,
  immediate: true,
})

watch(
  () => props.search,
  search => {
    lm.value = buildHomeKanbanQuery({
      category: props.source.category,
      pipelineMode: props.source.pipelineMode,
      search,
    })
  }
)

watch(
  [model, pending],
  () => {
    emit('update', {
      key: props.source.key,
      source: props.source,
      rows: model.value?.data || [],
      total: Number(model.value?.total_count || 0),
      pending: Boolean(pending.value),
    })
  },
  { immediate: true, deep: true }
)
</script>
